var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 102,
    viewBox: "0 0 114 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 130",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.23828 96.3659V77.2734C6.23828 73.9146 13.0444 71.1904 21.436 71.1904H55.8024C64.197 71.1904 71.0002 73.9146 71.0002 77.2734V97.0952L6.23828 96.3659Z",
    fill: "#FAECE5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 140",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.324 3.43464C50.2621 1.29226 44.0793 1.00262 43.0763 0.867274C31.0588 -0.753875 23.8258 16.7764 23.401 22.0894C22.6164 31.8803 17.4572 33.3729 10.1976 39.5033C-4.36265 51.7996 -0.0942626 66.0861 7.86729 71.3932C12.646 74.5798 21.0648 71.3932 21.0648 71.3932C21.1828 71.4761 44.0911 58.5371 55.383 52.2942C72.312 49.8776 64.6749 8.89276 54.324 3.43464Z",
    fill: "#353131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 141",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7111 47.0445C33.1604 45.4968 30.4737 39.7451 30.5241 39.7422C32.1392 39.6691 34.5165 37.4136 35.8821 28.2858L36.1901 28.5029L47.5234 33.4932C47.5234 33.4932 46.6862 37.1472 46.1429 40.6257C45.6887 43.5484 45.4423 46.3482 46.0747 46.7607C46.1251 46.7929 40.4815 48.6886 36.7111 47.0445Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 142",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5238 33.2313C47.5238 33.2313 46.7028 36.9186 46.1701 40.4287C39.6606 39.2419 37.1045 32.6645 36.1904 29.0953L47.5238 33.2313Z",
    fill: "#ED975D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 143",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8905 36.377C49.8905 36.377 33.9984 34.2743 35.4781 24.5535C36.9578 14.8328 35.9047 8.0136 46.1136 8.94162C56.3225 9.87258 57.7246 13.8725 58.0319 17.2351C58.3392 20.5977 54.0611 36.6707 49.8905 36.377Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 144",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2378 12.881C57.2378 12.881 47.3425 21.762 40.6131 22.4784C33.8808 23.1948 31.333 20.9428 31.333 20.9428C31.333 20.9428 35.2998 17.5119 37.688 11.9742C38.3903 10.3418 39.8789 9.22341 41.591 9.06925C46.3965 8.63699 55.5054 8.44051 57.2378 12.881Z",
    fill: "#353131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 145",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7617 11.5623C50.7617 11.5623 54.1129 14.8438 55.1712 17.2775C56.1883 19.6279 56.494 25.2449 55.6827 27.4763C55.6827 27.4763 60.9093 17.1942 57.9491 12.1989C54.8125 6.90022 50.7617 11.5623 50.7617 11.5623Z",
    fill: "#353131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 146",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0623 98.0321C55.2231 98.7491 52.8703 99.1776 49.7754 99.3787C40.0374 100.02 22.923 98.4314 22.2722 96.6504C20.0254 90.4884 21.6126 88.5733 19.7398 79.1379C19.5425 78.1352 19.301 77.0479 19.0184 75.8645C17.4547 69.3847 15.9353 67.1811 21.4772 56.7692C26.5037 47.3396 31.3433 39.3491 31.8144 39.626C45.0743 47.4174 46.0483 41.7254 46.0483 41.7254C46.0483 41.7254 59.8963 54.8541 59.6636 70.1863C59.1895 101.617 59.5341 95.0472 56.0623 98.0321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 149",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2238 96.6601C20.9556 90.4025 21.8907 87.6348 20 78.0529L25.178 65.5238C25.178 65.5238 24.3961 80.3273 28.778 84.2199C33.1599 88.1124 46.7278 91.7356 48.8593 94.9887C49.8879 96.5517 50.5657 98.1146 50.7619 99.3727C40.9308 100.024 23.8808 98.4688 23.2238 96.6601Z",
    fill: "#FAECE5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 150",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6191 93.0599C38.6191 93.0599 48.2209 90.7146 49.7692 91.6482C51.3175 92.585 55.1028 95.9898 55.5797 97.1754C56.0536 98.361 52.1299 96.2741 50.8524 95.8994C50.0282 95.6571 47.85 96.4841 46.7756 96.8782C42.2426 98.5386 39.4669 97.6858 39.4669 97.6858L38.6191 93.0599Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 151",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0496 46.0865C8.80187 54.7538 -3.58831 91.6882 3.51395 96.6173C11.5117 102.164 39.909 98.0672 39.909 98.0672C39.909 98.0672 40.8542 93.6738 39.5403 91.5456C38.2234 89.4202 16.8581 85.9876 15.8719 85.0065C14.8858 84.0253 28.1978 65.8726 28.1978 62.9291C28.1978 59.9857 31.8144 39.619 31.8144 39.619C31.8144 39.619 19.486 39.9288 15.0496 46.0865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 152",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9521 94.6667C49.9521 94.6667 52.1187 97.3388 52.8293 97.6569C53.5398 97.975 53.9998 97.8962 53.9998 97.8962L52.5406 95.3847L49.9521 94.6667Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 153",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1426 92.2382L55.6188 95.098C55.6188 95.098 55.3417 95.507 54.5465 95.4744C53.7479 95.4418 51.737 94.772 51.737 94.772L49.1426 92.2382Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 154",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1904 101.143H99.241L113.095 66.3333H67.1149L53.1904 101.143Z",
    fill: "#353131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 155",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.3334 99.5238H38.6191V101.143H98.7952L99.3334 99.5238Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 156",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.0948 83.7367C87.4659 82.62 86.7207 81.7142 85.4298 81.7142C84.142 81.7142 82.798 82.62 82.427 83.7367C82.059 84.8534 82.8043 85.7619 84.0921 85.7619C85.383 85.7619 86.7269 84.8534 87.0948 83.7367Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.a542b24f62e9da92b871de4bf01bbdac.svg";
export { ForwardRef as ReactComponent };